import getUserCustomerGroup from './getUserCustomerGroup';
const isProductEnabledForUserGroup = (productGroupsString, userCustomerGroup) => {
    const currentUserCustomerGroups = userCustomerGroup || getUserCustomerGroup();
    if (!currentUserCustomerGroups || !productGroupsString) {
        return false;
    }
    const productGroups = Array.isArray(productGroupsString)
        ? productGroupsString
        : productGroupsString.replace('[', '').replace(']', '').split(',');
    if (Array.isArray(currentUserCustomerGroups)) {
        return currentUserCustomerGroups.some((usergroup) => productGroups.includes(usergroup));
    }
    return productGroups.includes(currentUserCustomerGroups);
};
export default isProductEnabledForUserGroup;
//# sourceMappingURL=isProductEnabledForUserGroup.js.map